var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgSidebarDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274,
    height: 568,
    viewBox: "0 0 274 568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h274v568H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#483EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6259FF",
    d: "M86.275 613c96.622-10.132 195.201-153.076 138.5-215.578-56.7-62.503-101.236 38.168-184.174 53.212-82.939 15.044-136.43 30.083-136.43 88.459 0 58.375 85.483 84.04 182.104 73.908Z",
    mask: "url(#b)",
    transform: "rotate(73 72.797 496.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9818E",
    d: "M207.085 608.672c66.58-6.982 134.508-105.481 95.437-148.55-39.071-43.07-69.76 26.3-126.91 36.667C118.46 507.156 81.6 517.52 81.6 557.744c0 40.225 58.905 57.91 125.485 50.928Z",
    mask: "url(#b)",
    transform: "rotate(-19 197.797 528.16)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 5,
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m165 469.206 10.607-10.806M209.155 474.69l-12.505-10.503M187.257 489.101l-6.909 14.798"
  })), /*#__PURE__*/React.createElement("circle", {
    cy: 480,
    r: 67,
    fill: "#FFAF7E",
    mask: "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSidebarDesktop);
export default __webpack_public_path__ + "static/media/bg-sidebar-desktop.8f71ab813400ce8f657a6cf4f428b537.svg";
export { ForwardRef as ReactComponent };